module.exports = __webpack_public_path__ + "static/media/tick.0c98bc46.svg";